import {createSlice} from "@reduxjs/toolkit";

import {setIsDashboardInitDispatch} from "../dispatch/schedule/dashboard-init/set-is-dashboard-init";
import {clearDateToWorkDispatch} from "../dispatch/schedule/date-to-work/clear-date-to-work";
import {setDateToWorkDispatch} from "../dispatch/schedule/date-to-work/set-date-to-work";
import {clearDialogScheduleDispatch} from "../dispatch/schedule/dialog-schedule/clear-dialog-schedule";
import {setDialogScheduleDispatch} from "../dispatch/schedule/dialog-schedule/set-dialog-schedule";
import {clearPreviewDispatch} from "../dispatch/schedule/preview/clear-preview";
import {setPreviewDispatch} from "../dispatch/schedule/preview/set-preview";
import {addSchedulePageDispatch} from "../dispatch/schedule/schedule-page-all/add-schedule-page";
import {setSchedulePageAllDispatch} from "../dispatch/schedule/schedule-page-all/set-schedule-page-all";
import {setSchedulePageAllByDtoDispatch} from "../dispatch/schedule/schedule-page-all/set-schedule-page-all-by-dto";
import {clearSchedulePageDispatch} from "../dispatch/schedule/schedule-page/clear-schedule-page";
import {setSchedulePageDispatch} from "../dispatch/schedule/schedule-page/set-schedule-page";
import {setSchedulePageByDtoDispatch} from "../dispatch/schedule/schedule-page/set-schedule-page-by-dto";
import {clearSelectedClientIdsDispatch} from "../dispatch/schedule/selected-client/clear-selected-client-ids";
import {setSelectedClientIdsDispatch} from "../dispatch/schedule/selected-client/set-selected-client-ids";
import {clearSelectedScheduleDispatch} from "../dispatch/schedule/selected-schedule/clear-selected-schedule";
import {setSelectedScheduleDispatch} from "../dispatch/schedule/selected-schedule/set-selected-schedule";
import {clearSelectedStatusDispatch} from "../dispatch/schedule/selected-status/clear-selected-status";
import {setSelectedStatusDispatch} from "../dispatch/schedule/selected-status/set-selected-status";
import {clearUpdateScheduleDispatch} from "../dispatch/schedule/update-schedule/clear-update-schedule";
import {setUpdateScheduleDispatch} from "../dispatch/schedule/update-schedule/set-update-schedule";
import {RootState} from "../store";
import {ScheduleState} from "../type/schedule-state";
import {removeScheduleByIdDispatch} from "../dispatch/schedule/remove-schedule/remove-schedule";
import {
    setSelectedClientIdsListWithClearDispatch
} from "../dispatch/schedule/selected-client/set-selected-client-ids-list-with-clear";

const initialPage = {
    contents: [],
    first: true,
    last: true,
    page: 0,
    totalPages: 1,
    totalElements: 0,
};

const initialState: ScheduleState = {
    selectedSchedule: undefined,
    updateSchedule: undefined,
    dialogSchedule: undefined,
    dialogDeliveryGroupIndex: undefined,
    selectedStatus: [],
    selectedClientIds: [],
    schedulePage: initialPage,
    schedulePageAll: initialPage,
    searchSchedulePage: initialPage,
    dateToWork: "",
    preview: [],
    deliverySegments: [],
    isDashboardInit: false,
    status: "idle",
};

export const scheduleSlice = createSlice({
    name: "scheduleSlice",
    initialState,
    reducers: {
        clearSelectedScheduleAction: clearSelectedScheduleDispatch,
        setSelectedScheduleAction: setSelectedScheduleDispatch,
        setSchedulePageByDtoAction: setSchedulePageByDtoDispatch,
        setSchedulePageAction: setSchedulePageDispatch,
        clearSchedulePageAction: clearSchedulePageDispatch,
        setSchedulePageAllByDtoAction: setSchedulePageAllByDtoDispatch,
        setSchedulePageAllAction: setSchedulePageAllDispatch,
        setDateToWorkAction: setDateToWorkDispatch,
        clearDateToWorkAction: clearDateToWorkDispatch,
        setUpdateScheduleAction: setUpdateScheduleDispatch,
        clearUpdateScheduleAction: clearUpdateScheduleDispatch,
        setPreviewAction: setPreviewDispatch,
        clearPreviewAction: clearPreviewDispatch,
        setDialogScheduleAction: setDialogScheduleDispatch,
        clearDialogScheduleAction: clearDialogScheduleDispatch,
        setSelectedStatusAction: setSelectedStatusDispatch,
        clearSelectedStatusAction: clearSelectedStatusDispatch,
        setSelectedClientIdsAction: setSelectedClientIdsDispatch,
        setSelectedClientIdsListWithClearAction: setSelectedClientIdsListWithClearDispatch,
        clearSelectedClientIdsAction: clearSelectedClientIdsDispatch,
        addSchedulePageAction: addSchedulePageDispatch,
        setIsDashboardInitAction: setIsDashboardInitDispatch,
        removeScheduleByIdAction: removeScheduleByIdDispatch,
    },
});

export const {
    clearSelectedScheduleAction,
    setSelectedScheduleAction,
    setSchedulePageByDtoAction,
    setSchedulePageAction,
    clearSchedulePageAction,
    setSchedulePageAllByDtoAction,
    setSchedulePageAllAction,
    setDateToWorkAction,
    clearDateToWorkAction,
    setUpdateScheduleAction,
    clearUpdateScheduleAction,
    setPreviewAction,
    clearPreviewAction,
    setDialogScheduleAction,
    clearDialogScheduleAction,
    setSelectedStatusAction,
    clearSelectedStatusAction,
    setSelectedClientIdsAction,
    setSelectedClientIdsListWithClearAction,
    clearSelectedClientIdsAction,
    addSchedulePageAction,
    setIsDashboardInitAction,
    removeScheduleByIdAction,
} = scheduleSlice.actions;

export const scheduleState = (state: RootState) => state.schedule;

export default scheduleSlice.reducer;
